export default __webpack_public_path__ + "static/media/photo_business-insider.ba2dc73a.jpg";